import { ReviewThreadStatus } from "@/api/cle-api";
import type { StatusBadgeVariant } from "@/components/pages/person/id/Efteruddannelse/StatusBadge";

export const formatReviewThreadStatus = (status: string): string => {
  switch (status) {
    case ReviewThreadStatus.OPEN:
      return "Åben";
    case ReviewThreadStatus.RESOLVED:
      return "Løst";
    default:
      return status;
  }
};

export const getReviewThreadStatusVariant = (
  status: string,
): StatusBadgeVariant => {
  switch (status) {
    case ReviewThreadStatus.OPEN:
      return "warning";
    case ReviewThreadStatus.RESOLVED:
      return "success";
    default:
      return "muted";
  }
};
